import { Component, OnInit } from '@angular/core';
import { Messages } from '@app/src/util/messages.util';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})

export class AccessDeniedComponent implements OnInit {

  /*************** Variable declarations ***************/
  public msg = Messages;

  /**
   * Constructor
   */
  constructor() {
  }

  ngOnInit(): void {

  }
}
